module.exports = {
  init: function () {
    const testimonials = $('.js-carousel-testimonials');
    if (testimonials.length > 0) {
      testimonials.slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        centered: true,
        autoplay: true,
        autoplaySpeed: 6000,
        appendDots: $('.js-testimonials-slick-slider-dots'),
        responsive: [
          {
            breakpoint: 1023.98,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 767.98,
            settings: {
              arrows: false,
              slidesToShow: 1,
            }
          },
        ]
      });
    }
  }
}
